import type { Submission, UpdateEndorsementDataPayload } from '@root/@types/types';
import axios from 'axios';

import { getRequestAuthPayload } from '../helpers/getRequestAuth';
import { queryClient } from '../utils/queryClient';

export const createEndorsement =
  (submissionId: string) =>
  async (data: UpdateEndorsementDataPayload): Promise<Pick<Submission, 'id'>> => {
    const networkPayload = await getRequestAuthPayload({
      method: 'post',
      url: `submissions/${submissionId}/endorsements`,
      data,
    });

    const response = await axios(networkPayload);
    await queryClient.invalidateQueries({ queryKey: ['submissions'] });
    return response?.data;
  };
